import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import CardDropdown from 'components/common/CardDropdown';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { claimantChildrenAPI } from 'utils/api/fulcrum-api';

const ClaimantChildRow = ({ child, claimant, getClaimantChildren = () => { } }) => {
	let defaultFormData = {
		name: child.name,
		age: child.age
	};
	const [formData, setFormData] = useState(defaultFormData);
	const [previousFormData, setPreviousFormData] = useState(defaultFormData);

	// Remove a child
	const removeChild = () => {
		Swal.fire({
			title: 'Permanently delete this child record?',
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCansetFormDatalButton: true,
			confirmButtonColor: '#3085d6',
			cansetFormDatalButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!',
			cancelButtonColor: '#d33',
			showCancelButton: true,
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					let result = await claimantChildrenAPI.deleteClaimantChild(claimant.id, child.id);
					if (!result?.message) {
						throw new Error('No data returned from server');
					}
					getClaimantChildren();
					toast.warning('Child removed', { theme: 'colored' });
				} catch (error) {
					console.error(error);
					toast.error('Error deleting child', { theme: 'colored' });
				}
			}
		});
	};

	// Update a child
	const updateCurrentChild = async (childId, data) => {
		try {
			let result = await claimantChildrenAPI.updateClaimantChild(claimant.id, childId, data);
			console.log(result);
			if (!result) {
				throw new Error('Unable to update child');
			}
			setPreviousFormData({ ...formData, ...data });

		} catch (error) {
			console.error(error);
			toast.error('Error updating child', {
				theme: 'colored'
			});
		}
	};

	// Save on change
	const saveOnChange = async (e, saveChange) => {
		let { name, value } = e.target;

		if (saveChange && previousFormData[name] !== value) {
			await updateCurrentChild(child.id, { [name]: value });
		}

		setFormData({ ...formData, [name]: value });
	};

	useEffect(() => {
		let childData = {
			name: child.name,
			age: child.age
		};
		setFormData(childData);
		setPreviousFormData(childData);
	}, [child])

	return (
		<>
			<td className="px-0">
				<Form.Control
					type="text"
					size="sm"
					name="name"
					value={formData.name}
					onChange={e => saveOnChange(e, false)}
					onBlur={e => saveOnChange(e, true)}
				/>
			</td>
			<td className="px-0">
				<Form.Control
					type="number"
					size="sm"
					name="age"
					value={formData.age}
					onChange={e => saveOnChange(e, false)}
					onBlur={e => saveOnChange(e, true)}
				/>
			</td>
			<td>
				<div className="d-flex justify-content-between float-end">
					<CardDropdown>
						<div className="py-2">
							<Dropdown.Item onClick={() => { removeChild(child.id) }} className="text-danger">Delete</Dropdown.Item>
						</div>
					</CardDropdown>
				</div>
			</td>
		</>
	);
};

export default ClaimantChildRow;